import styled from "styled-components";

const SingleDatePickerWrapper = styled.div`
  width: 100%;
  position: relative;

  .SingleDatePicker {
    width: 100%;
  }

  .SingleDatePickerInput {
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 1rem;
  }

  .SingleDatePickerInput__withBorder {
    border-radius: 8px;
    border: none;
  }

  .DateInput {
    width: 100%;
  }

  .SingleDatePicker .SingleDatePickerInput .DateInput input {
    color: var(--grey-95, #0C0D0D) !important;
  }

  .DateInput_input {
    font-size: 1rem;
    padding: 6px 12px !important;
    width: 100%;
    &::placeholder {
      color: var(--grey-30, #AFB2B6) !important;
    }
  }

  .DateInput_input__focused {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  .SingleDatePicker_picker {
    z-index: 1000;
  }
  .SingleDatePickerInput_calendarIcon {
    position: absolute;
    width: 100%;
    margin: 0;
  }
`;

const NoEndDate = styled.div`
  position: absolute;
  inset: 0px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: left;
  padding-left: 10px;
  background-color: #edebed;
  color: grey;
  border-radius: 8px;
  pointer-events: none;
  z-index: 1;
  height: 35px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
`;

export { NoEndDate, SingleDatePickerWrapper };
